import React from 'react'
import './experience.css'
import { BsPatchCheckFill } from 'react-icons/bs'

const Experience = () => {
    return (
        <section id="experience">
            <div className="container experience__container">

                <article className="experience__card">
                    <h3>Software Engineering</h3>
                    <div className="experience__content">

                        <div className="experience__details">
                            <span className="experience__details-icon">💻</span>
                            <div>
                                <h4>Full-Stack Development</h4>
                                <p>Building scalable web apps with modern Java (8–21), Spring Boot, Angular, and
                                    Tailwind.</p>
                            </div>
                        </div>

                        <div className="experience__details">
                            <span className="experience__details-icon">⚡</span>
                            <div>
                                <h4>System Design</h4>
                                <p>Designing clean architectures, reusable APIs, and distributed backends.</p>
                            </div>
                        </div>

                        <div className="experience__details">
                            <span className="experience__details-icon">🛠️</span>
                            <div>
                                <h4>DevOps & CI/CD</h4>
                                <p>Hands-on with Docker, Kubernetes, Jenkins, Maven, Ansible, and GitHub Actions.</p>
                            </div>
                        </div>

                    </div>
                </article>

                <article className="experience__card">
                    <h3>Cloud & Data</h3>
                    <div className="experience__content">

                        <div className="experience__details">
                            <span className="experience__details-icon">☁️</span>
                            <div>
                                <h4>Cloud Platforms</h4>
                                <p>Deploying and managing apps on AWS, Azure, and Google Cloud.</p>
                            </div>
                        </div>

                        <div className="experience__details">
                            <span className="experience__details-icon">📊</span>
                            <div>
                                <h4>Data Engineering</h4>
                                <p>Exploring pipelines, analytics, and reporting with SQL, Yellowfin, and LOGI.</p>
                            </div>
                        </div>

                        <div className="experience__details">
                            <span className="experience__details-icon">🚀</span>
                            <div>
                                <h4>Agile & Collaboration</h4>
                                <p>Working in Scrum teams, mentoring interns, and bridging business with technology.</p>
                            </div>
                        </div>

                    </div>
                </article>

            </div>
        </section>

    )
}

export default Experience
